import { j as o } from "../../jsx-runtime.BREq8dyb.js";
import { Modal as l, ModalDialog as c, DialogTitle as d, ModalClose as x, Divider as h } from "@mui/joy";
import { memo as j } from "react";
import p from "../../components/DatasetUploader/containers/DatasetContainer/DatasetContainer.js";
import f from "../../components/DatasetUploader/containers/FeatureContainer/FeatureContainer.js";
import C from "../../components/DatasetUploader/containers/FileContainer/FileContainer.js";
import u from "../../components/DatasetUploader/containers/IntrospectionContainer/IntrospectionContainer.js";
import { a as g, V as D } from "../../Prepper.DvRmOOuJ.js";
import M from "../../components/DatasetUploader/containers/OptionsContainer/OptionsContainer.js";
import k from "../../components/DatasetUploader/containers/SchemaContainer/SchemaContainer.js";
import B from "../../components/DatasetUploader/containers/TypificationContainer/TypificationContainer.js";
import t from "../../components/DatasetUploader/containers/WorkerContainer/WorkerContainer.js";
import { ErrorHandler as y } from "../../components/DatasetUploader/handlers/ErrorHandler/ErrorHandler.js";
const E = j(({
  DialogTitleChildren: n = "Provision dataset to node",
  DialogTitleProps: e,
  DatasetUploaderProps: i,
  onClose: r,
  onError: a,
  open: s = !0
}) => {
  const m = () => {
    r?.();
  };
  return /* @__PURE__ */ o.jsx(l, { onClose: r, open: s, children: /* @__PURE__ */ o.jsxs(c, { sx: {
    "--ModalDialog-maxWidth": "100%",
    "--ModalDialog-minWidth": "100%",
    height: "100%"
  }, children: [
    /* @__PURE__ */ o.jsxs(d, { ...e, children: [
      /* @__PURE__ */ o.jsx(x, { sx: {
        "--ModalClose-inset": "0.75rem"
      } }),
      n
    ] }),
    /* @__PURE__ */ o.jsx(h, { inset: "context" }),
    /* @__PURE__ */ o.jsx(y, { onError: a, children: /* @__PURE__ */ o.jsx(k, { schema: i?.schema, children: /* @__PURE__ */ o.jsx(C, { children: /* @__PURE__ */ o.jsx(u, { children: /* @__PURE__ */ o.jsx(t, { children: /* @__PURE__ */ o.jsx(B, { children: /* @__PURE__ */ o.jsx(M, { children: /* @__PURE__ */ o.jsx(g, { children: /* @__PURE__ */ o.jsx(t, { children: /* @__PURE__ */ o.jsx(p, { initArguments: i?.initArguments, children: /* @__PURE__ */ o.jsx(f, { children: /* @__PURE__ */ o.jsx(D, { BackButtonProps: {
      onClick: m
    }, OkayButtonProps: i?.OkayButtonProps, extractSchemaMode: !0 }) }) }) }) }) }) }) }) }) }) }) })
  ] }) });
});
E.displayName = "DatasetSchemaExtractionDialog";
export {
  E as default
};
//# sourceMappingURL=DatasetSchemaExtractionDialog.js.map
